import {
  updateDiamondAndAvailproCodes,
  updateDate,
  showResortErrorMessage,
  updateTextField,
  setStateFromJson,
  blurInput,
  changeDurationValue,
  changeScanDaysValue
} from './core';
import {fromJS, Map, OrderedMap} from 'immutable';
import moment from 'moment/moment';
import {sessionCache} from 'locache';

const accommodationMap = document.getElementsByClassName('json-accommodation-map');
let jsonAccommodationMap;
let selectedDate;
const scanDays = 0;
let seasonStartDate = moment();
let seasonEndDate = moment();
if (accommodationMap.length > 0) {
  jsonAccommodationMap = accommodationMap[0].getAttribute('data-accommodationMap');

  seasonStartDate = moment(accommodationMap[0].getAttribute('data-seasonStart'), 'DD/MM/YYYY');
  seasonEndDate = moment(accommodationMap[0].getAttribute('data-seasonEnd'), 'DD/MM/YYYY');
  const nextStartDate = moment(seasonStartDate).subtract(7, 'days');
  do {
    nextStartDate.add(7, 'days');
  } while (nextStartDate.isBefore(seasonStartDate) || nextStartDate.isBefore(moment()));
  selectedDate = moment().isBefore(seasonStartDate) ? seasonStartDate : moment().isAfter(seasonEndDate) ? seasonEndDate : nextStartDate;

}

let TEMP_INITIAL_STATE = Map({
  inputFields: Map({
    regions: Map({
      value: 'Any',
      diamondCode: '',
      availproCode: ''
    }),
    resorts: Map({
      value: 'Any',
      diamondCode: '',
      availproCode: ''
    }),
    accommodation: Map({
      value: 'Any',
      diamondCode: '',
      availproCode: ''
    })

  }),
  selectedDate,
  scanDays,
  seasonStartDate: seasonStartDate.format('DD/MM/YYYY'),
  seasonEndDate: seasonEndDate.format('DD/MM/YYYY'),
  availableResortNames: null,
  availableRegionNames: null,
  availableAccommodationNames: null,
  regions: OrderedMap({
    tarentaise: Map({
      name: 'Tarentaise',
      diamondCode: 123,
      availproCode: 214,
      nodeId: 12345,
      resorts: Map({
        sainteFoy: Map({
          name: 'Sainte Foy',
          diamondCode: 1234,
          availproCode: 2145,
          nodeId: 12345,
          accommodation: Map({
            lesFermesDeSainteFoy: Map({
              name: 'Les Fermes de Sainte Foy',
              diamondCode: 9289,
              availproCode: 9289,
              nodeId: 12345
            }),
            etoileDesCimes: Map({
              name: 'Etoile des Cimes',
              diamondCode: 9299,
              availproCode: 9299,
              nodeId: 12345
            }),
            leRuitor: Map({
              name: 'Le Ruitor',
              diamondCode: 9209,
              availproCode: 9209,
              nodeId: 12345
            })
          })
        }),
        tignes1800: Map({
          name: 'Tignes 1800',
          diamondCode: 1333,
          availproCode: 2225,
          accommodation: Map({
            kalinda: Map({
              name: 'Kalinda',
              diamondCode: 1299,
              availproCode: 1299,
              nodeId: 12345
            }),
            altaviva: Map({
              name: 'Altaviva',
              diamondCode: 1209,
              availproCode: 1209,
              nodeId: 12345
            })
          })
        }),
        tignesLesBrevieres: Map({
          name: 'Tignes les Brevieres',
          diamondCode: 111,
          availproCode: 2111,
          nodeId: 12345,
          accommodation: Map({
            clubHotelLesBrevieres: Map({
              name: 'Club Hotel Les Brevieres',
              diamondCode: 'david code,123,123,thomascode,1799',
              availproCode: 1799,
              nodeId: 12345
            }),
            santaTerra: Map({
              name: 'Santa Terra',
              diamondCode: 12709,
              availproCode: 12709,
              nodeId: 12345
            })
          })
        })
      })
    }),
    ftarentaise: Map({
      name: 'Super Tarentaise',
      diamondCode: 123,
      availproCode: 214,
      nodeId: 12345,
      resorts: Map({
        sainteFoy: Map({
          name: 'Sainte Foy',
          diamondCode: 1234,
          availproCode: 2145,
          nodeId: 12345,
          accommodation: Map({
            lesFermesDeSainteFoy: Map({
              name: 'Les Fermes de Sainte Foy',
              diamondCode: 9289,
              availproCode: 9289,
              nodeId: 12345
            }),
            etoileDesCimes: Map({
              name: 'Etoile des Cimes',
              diamondCode: 9299,
              availproCode: 9299,
              nodeId: 12345
            }),
            leRuitor: Map({
              name: 'Le Ruitor',
              diamondCode: 9209,
              availproCode: 9209,
              nodeId: 12345
            })
          })
        }),
        tignes1800: Map({
          name: 'Tignes 1800',
          diamondCode: 1333,
          availproCode: 2225,
          nodeId: 12345,
          accommodation: Map({
            kalinda: Map({
              name: 'Kalinda',
              diamondCode: 1299,
              availproCode: 1299,
              nodeId: 12345
            }),
            altaviva: Map({
              name: 'Altaviva',
              diamondCode: 1209,
              availproCode: 1209,
              nodeId: 12345
            })
          })
        }),
        tignesLesBrevieres: Map({
          name: 'Tignes les Brevieres',
          diamondCode: 111,
          availproCode: 2111,
          nodeId: 12345,
          accommodation: Map({
            clubHotelLesBrevieres: Map({
              name: 'Club Hotel Les Brevieres',
              diamondCode: 1799,
              availproCode: 1799,
              nodeId: 12345
            }),
            santaTerra: Map({
              name: 'Santa Terra',
              diamondCode: 12709,
              availproCode: 12709,
              nodeId: 12345
            })
          })
        })
      })
    }),
    gtarentaise: Map({
      name: 'Greater Tarentaise',
      diamondCode: 123,
      availproCode: 214,
      nodeId: 12345,
      resorts: Map({
        sainteFoy: Map({
          name: 'Sainte Foy',
          diamondCode: 1234,
          availproCode: 2145,
          nodeId: 12345,
          accommodation: Map({
            lesFermesDeSainteFoy: Map({
              name: 'Les Fermes de Sainte Foy',
              diamondCode: 9289,
              availproCode: 9289,
              nodeId: 12345
            }),
            etoileDesCimes: Map({
              name: 'Etoile des Cimes',
              diamondCode: 9299,
              availproCode: 9299,
              nodeId: 12345
            }),
            leRuitor: Map({
              name: 'Le Ruitor',
              diamondCode: 9209,
              availproCode: 9209,
              nodeId: 12345
            })
          })
        }),
        tignes1800: Map({
          name: 'Tignes 1800',
          diamondCode: 1333,
          availproCode: 2225,
          nodeId: 12345,
          accommodation: Map({
            kalinda: Map({
              name: 'Kalinda',
              diamondCode: 1299,
              availproCode: 1299,
              nodeId: 12345
            }),
            altaviva: Map({
              name: 'Altaviva',
              diamondCode: 1209,
              availproCode: 1209,
              nodeId: 12345
            })
          })
        }),
        tignesLesBrevieres: Map({
          name: 'Tignes les Brevieres',
          diamondCode: 111,
          availproCode: 2111,
          nodeId: 12345,
          accommodation: Map({
            clubHotelLesBrevieres: Map({
              name: 'Club Hotel Les Brevieres',
              diamondCode: 1799,
              availproCode: 1799,
              nodeId: 12345
            }),
            santaTerra: Map({
              name: 'Santa Terra',
              diamondCode: 12709,
              availproCode: 12709,
              nodeId: 12345
            })
          })
        })
      })
    }),
    portesDuSoleil: Map({
      name: 'Portes du Soleil',
      diamondCode: 666,
      availproCode: 2614,
      nodeId: 12345,
      resorts: Map({
        lesGets: Map({
          name: 'Les Gets',
          diamondCode: 1215,
          availproCode: 21495,
          nodeId: 12345,
          accommodation: Map({
            lesFermesEmiguy: Map({
              name: 'Les Fermes Emiguy',
              diamondCode: 1729,
              availproCode: 1729,
              nodeId: 12345
            }),
            residenceAnnapurna: Map({
              name: 'Residence Annapurna',
              diamondCode: 12209,
              availproCode: 12209,
              nodeId: 12345
            })
          })
        }),
        chatel: Map({
          name: 'Chatel',
          diamondCode: 109,
          availproCode: 20925,
          nodeId: 12345,
          accommodation: Map({
            grandLodge: Map({
              name: 'Grand Lodge',
              diamondCode: 1769,
              availproCode: 1769,
              nodeId: 12345
            }),
            grandErmitage: Map({
              name: 'Grand Ermitage',
              diamondCode: 13209,
              availproCode: 13209,
              nodeId: 12345
            })
          })
        }),
        morzine: Map({
          name: 'Morzine',
          diamondCode: 19811,
          availproCode: 21095,
          accommodation: Map({
            hotelLeCret: Map({
              name: 'Hotel Le Cret',
              diamondCode: 'david code,123,123,thomascode,1799',
              availproCode: 1729,
              nodeId: 12345
            })
          })
        })
      })
    }),
  })
});



let regionMap = Map({});

if (jsonAccommodationMap !== undefined) {
  try {

    const regions = fromJS(JSON.parse(jsonAccommodationMap));

    regions.valueSeq().forEach(region => {
      let resortMap = Map({});

      //get resorts map
      const resorts = region.get('Resorts');
      resorts.valueSeq().forEach(resort => {
        let accommodationMap = Map({});
        const urlEncodedKey = encodeURIComponent(resort.get('Name')).toLowerCase();

        const accommodations = resort.get('Accommodations');
        accommodations.valueSeq().forEach(accommodation => {
          const urlEncodedKey = encodeURIComponent(accommodation.get('Name')).toLowerCase();
          const accommodationItem = Map({
            name: accommodation.get('Name'),
            diamondCode: accommodation.get('AvailproAccommodationId'),
            availproCode: accommodation.get('DiamondAccommodationCodes'),
            nodeId: accommodation.get('NodeId')
          });
          accommodationMap = accommodationMap.set(urlEncodedKey, accommodationItem);
        });

        const resortItem = Map({
          name: resort.get('Name'),
          diamondCode: resort.get('AvailProResortID'),
          availproCode: resort.get('DiamondResortCodes'),
          nodeId: resort.get('NodeId'),
          accommodation: accommodationMap
        });
        resortMap = resortMap.set(urlEncodedKey, resortItem);
      });

      const urlEncodedKey = encodeURIComponent(region.get('Name')).toLowerCase();
      const regionItem = Map({
        name: region.get('Name'),
        diamondCode: region.get('AvailProRegionID'),
        availproCode: region.get('DiamondRegionCodes'),
        nodeId: region.get('NodeId'),
        resorts: resortMap
      });
      regionMap = regionMap.set(urlEncodedKey, regionItem);
    });
    //console.log(INITIAL_STATE.get('regions'));
  } catch (e) {
    console.error(e);
  }
}

TEMP_INITIAL_STATE = TEMP_INITIAL_STATE.set('regions', regionMap);
if (sessionCache('duration') !== 'Other' && sessionCache('bookingDate').get() !== null) {
  TEMP_INITIAL_STATE = TEMP_INITIAL_STATE.set('selectedDate', moment(sessionCache('bookingDate').get(), 'DD/MM/YYYY'));
}

if (sessionCache('duration').get() === 'Other' && sessionCache('bookingDate').get() !== null && sessionCache('endDate').get() !== null) {
  TEMP_INITIAL_STATE = TEMP_INITIAL_STATE.set('selectedDate', moment(sessionCache('bookingDate').get(), 'DD/MM/YYYY'))
    .set('endDate', moment(sessionCache('endDate').get(), 'DD/MM/YYYY')).set('duration', 'Other');
}

const bookingRegion = sessionCache('bookingRegion').get();
const bookingResort = sessionCache('bookingResort').get();
const bookingAccommodation = sessionCache('bookingAccommodation').get();

if (null !== bookingRegion) {
  TEMP_INITIAL_STATE = TEMP_INITIAL_STATE.setIn(['inputFields', 'regions', 'value'], bookingRegion);
}
if (null !== bookingResort) {
  TEMP_INITIAL_STATE = TEMP_INITIAL_STATE.setIn(['inputFields', 'resorts', 'value'], bookingResort);
}
if (null !== bookingAccommodation) {
  TEMP_INITIAL_STATE = TEMP_INITIAL_STATE.setIn(['inputFields', 'accommodation', 'value'], bookingAccommodation);
}

export const INITIAL_STATE = TEMP_INITIAL_STATE;

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'SET_STATE_FROM_JSON' :
      return setStateFromJson(action.payload.newState);
    case 'UPDATE_TEXT_FIELD' :
      return updateTextField(state, action.payload.name, action.payload.value, action.payload.inOnChange);
    case 'BLUR_INPUT':
      return blurInput(state, action.payload.name, action.payload.value);
    case 'UPDATE_DATE':
      return updateDate(state, action.payload.date, action.payload.endDate);
    case 'SHOW_RESORT_ERROR_MESSAGE':
      return showResortErrorMessage(state, action.payload.show);
    case 'UPDATE_DIAMOND_AND_AVAILPRO_CODES':
      return updateDiamondAndAvailproCodes(state);
    case 'CHANGE_DURATION_VALUE':
      return changeDurationValue(state, action.payload.value);
    case 'CHANGE_SCANDAYS_VALUE':
      return changeScanDaysValue(state, action.payload.value);
  }
  return state;
}
